module.exports = __webpack_public_path__ + "img/magazine-info-m.9b5f38e7.png";